import { AsYouType } from 'libphonenumber-js'

const filterNonValidPhoneChar = (value: string) => {
  return new AsYouType().input(value).replace(/\s+/g, '')
}

export default filterNonValidPhoneChar
